module.exports = __webpack_public_path__ + "static/media/mapa-a1.0be12480.png";